import { Route, BrowserRouter as Router, Routes, useNavigate, useLocation } from 'react-router-dom';
import './assets/scss/global.css';
import { AppHeader } from './cmps/AppHeader';
import { Toaster } from './components/ui/toaster';
import { lazy, Suspense, useEffect } from 'react';

import { LoadingProvider } from './cmps/LoadingContext';
import LazyLoading from './cmps/LazyLoading';
import { utilService } from './services/util.service';
import { AppFooter } from './cmps/AppFooter';
import { CookieConsentBanner } from './cmps/CookieConsentBanner';

import { disableReactDevTools } from '@fvilers/disable-react-devtools'



if (process.env.REACT_APP_NODE_ENV === 'production') {
    disableReactDevTools()
}


const EmployeeDetails = lazy(() => import("./views/EmployeeDetails"))
const Home = lazy(() => import("./views/Home"))
const Jop = lazy(() => import("./views/Jop"))
const OpenPositions = lazy(() => import("./views/OpenPositions"))
const Careers = lazy(() => import("./views/Careers"))
const NotFound = lazy(() => import("./views/NotFound"))
const ThankYou = lazy(() => import("./views/ThankYou"))
const PrivacyPolicy = lazy(() => import("./views/PrivacyPolicy"))

const routes = [
    { path: '/', element: <Home /> },
    { path: '/careers', element: <Careers /> },
    { path: '/open-positions', element: <OpenPositions /> },
    { path: '/job', element: <Jop /> },
    { path: '/apply-form', element: <EmployeeDetails /> },
    { path: '/thank-you', element: <ThankYou /> },
    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '*', element: <NotFound /> },

];



function MainApp() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

        utilService.updateDocumentTitle(location)
    }, [location, navigate]);

    return (
        <div className="flex flex-col min-h-screen app-container">
            <AppHeader />
            <main className="flex-grow ">
                <Suspense fallback={<LazyLoading />}>
                    <Routes>
                        {routes.map((route) => (
                            <Route key={route.path} path={route.path} element={route.element} />
                        ))}
                    </Routes>
                </Suspense>
            </main>
            <AppFooter companyName="HAAT" year={new Date().getFullYear()} />
            <Toaster />
            <CookieConsentBanner />
        </div>
    );
}

function App() {
    return (
        <LoadingProvider>
            <Router>
                <MainApp />
            </Router>
        </LoadingProvider>
    );
}

export default App;
